import Service from '@/service/Service'

const PickupLocationService = {
    list: async function () {
        const response = await Service.api().get("pickup-location");
        return response.data;
    },
    listAll: async function () {
        const response = await Service.api().get("pickup-location/all");
        return response.data;
    },
    listWithDetails: async function () {
        const response = await Service.api().get("pickup-location/details");
        return response.data.map(PickupLocationService.format)
    },
    getId: async function (pickupLocationId) {
        const response = await Service.api().get("pickup-location/" + pickupLocationId);
        return response.data;
    },
    create: async function (location) {
        const response = await Service.api().post("pickup-location", location);
        return PickupLocationService.format(response.data);
    },
    update: async function (location) {
        await Service.api().put("pickup-location/" + location.id, location);
    },
    format: function (location) {
        if(location.contact){
            location.contactFullname = location.contact.firstname + " " + location.contact.lastname
        }
        return location;
    }
}

export default PickupLocationService
